import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10 9.375a2.708 2.708 0 1 0 0-5.417 2.708 2.708 0 0 0 0 5.417Zm.208 6.667H5.791c-.983 0-1.716-.867-1.215-1.713.726-1.226 2.29-2.662 5.632-2.662M16 14h-5m2 2-2-2 2-2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);